module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-3-e9536a29f0c4359345014dc86edbe0f8.png";